import { motion } from "framer-motion";
import { MessageCircle, ShoppingBag } from "lucide-react";
import { LINKS } from "../config";
import { useLang } from "../i18n";

const BTNS = [
  { href: LINKS.whatsapp, icon: MessageCircle, key: "whatsapp", testid: "floating-whatsapp-button", cls: "bg-pine text-paper" },
  { href: LINKS.talabat, icon: ShoppingBag, key: "talabat", testid: "floating-talabat-button", cls: "bg-gold text-forest" },
];

export const FloatingCTAs = () => {
  const { t } = useLang();
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.8, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-6 right-6 z-40 flex flex-col gap-3"
      data-testid="floating-ctas"
      dir="ltr"
    >
      {BTNS.map((b) => (
        <a
          key={b.key}
          href={b.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t.floating[b.key]}
          data-testid={b.testid}
          className={`group flex items-center gap-3 ${b.cls} w-12 h-12 rounded-full justify-start ps-[15px] overflow-hidden hover:w-36 transition-[width] duration-400 ease-out shadow-lg shadow-forest/25`}
        >
          <b.icon size={18} className="shrink-0" />
          <span className="text-xs uppercase tracking-[0.15em] whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            {t.floating[b.key]}
          </span>
        </a>
      ))}
    </motion.div>
  );
};
